// extracted by mini-css-extract-plugin
module.exports = {"captchaBox":"style_captchaBox__D_e9q","tip":"style_tip__opwRT"};